import React from 'react';
import { Chip, useT } from '@repo/common';

const CouponsHeaderButton = ({ currentFilter, onFilterChange, $isMobile }) => {
  const t = useT();
  const couponStatuses = ['Active', 'Inactive'];

  const statusMapper = {
    Active: 'Active',
    Inactive: 'Inactive',
  };

  const statusLabelsKr = {
    Active: '사용 가능',
    Inactive: '만료됨',
  };

  return (
    <div className={`flex items-center gap-2 ${$isMobile && 'pb-4 w-full'}`}>
      {couponStatuses.map((status) => {
        const mappedValue = statusMapper[status];
        const isSelected = currentFilter === mappedValue;

        return (
          <Chip
            key={status}
            type='fill'
            state={isSelected ? 'selected' : 'default'}
            hideIcon={true}
            onClick={() => onFilterChange(mappedValue)}
            borderclass='ring-0'
          >
            {t(status, statusLabelsKr[status] || status)}
          </Chip>
        );
      })}
    </div>
  );
};

export default CouponsHeaderButton;
